export default "__VITE_ASSET__Ck3CahuW__"